<template>
  <a-layout-footer
    style="text-align: center"
    class="fixed bottom-0 left-0 right-0 font-semibold z-[90]"
  >
    <span class="text-coppy">{{ `Copyright ©2023 ` }}</span>
    <span class="mr-1 ml-1">Bản quyền thuộc về Công Ty Cổ Phần Đầu Tư Ngành Nước DNP</span>
  </a-layout-footer>
</template>

<script>
export default {
  name: 'GlobalFooter'
}
</script>

<style scoped></style>
